import React from 'react';
import PropTypes from 'prop-types';

import Asterisk from '../Asterisk';
import FieldError from '../FieldError';

const TextareaInput = ({
  name,
  label,
  required,
  values,
  errors,
  touched,
  className = '',
  inputClassName = '',
  disabled = false,
  readOnly = false,
  onChange = () => { },
  onBlur = () => { },
  placeholder,
  popover = null,
  rows,
  size,
  inline = false,
  labelWidth = 6,
  inputWidth = 6,
  dataPrivate = true,
  labelDescription = '',
}) => {
  let sizeClass = '';
  if (size === 'lg') {
    sizeClass = 'form-control-lg';
  } else if (size === 'sm') {
    sizeClass = 'form-control-sm';
  }

  let containerClassName = `form-group col-12 rounded ${className}`;
  if (!disabled && !readOnly && errors[name] && touched[name]) {
    containerClassName += ' has-danger';
  }
  if (readOnly) {
    containerClassName += ' bg-light-hover read-only';
  }
  if (inline) {
    containerClassName += ' row';
  }

  let labelClassName = 'form-label';
  if (inline) {
    labelClassName += ` col-12 col-sm-${labelWidth}`;
    if (readOnly) {
      labelClassName += ' mb-0';
    }
  } else {
    labelClassName += ' mb-0';
  }

  return (
    <div className={containerClassName}>
      <label htmlFor={name} className={labelClassName}>
        {label}{readOnly && ':'}{required && !readOnly && <Asterisk />}{popover}
      </label>
      {labelDescription && <div className='form-text'>{labelDescription}</div>}
      <div className={`${inline ? `col-12 col-sm-${inputWidth}` : ''}`} data-private={dataPrivate}>
        {readOnly
          ? <span>{values[name]}</span>
          : (
            <>
              <textarea
                name={name}
                value={values[name]}
                className={`form-control ${sizeClass} ${inputClassName}`}
                disabled={disabled}
                readOnly={readOnly}
                onChange={onChange}
                onBlur={onBlur}
                placeholder={placeholder}
                rows={rows}
                aria-label={name}
              />
              <FieldError error={errors[name]} touched={touched[name]} disabled={disabled} />
            </>
          )
        }
      </div>
    </div>
  );
};

TextareaInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  popover: PropTypes.node,
  rows: PropTypes.number,
  size: PropTypes.string,
  inline: PropTypes.bool,
  labelWidth: PropTypes.number,
  inputWidth: PropTypes.number,
  dataPrivate: PropTypes.bool,
};

export default TextareaInput;
